export const titleBidOverMultiplier = {
    "GHA_META": "Google Hotel Ads",
    "GHA_PPA": "Google Hotel Ads - Property Promotion Ads",
};